import { render, staticRenderFns } from "./BusinessMatchSharingProfile.vue?vue&type=template&id=5c23814e&scoped=true"
import script from "./BusinessMatchSharingProfile.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchSharingProfile.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchSharingProfile.vue?vue&type=style&index=0&id=5c23814e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23814e",
  null
  
)

export default component.exports